import { createRouter, createWebHistory } from 'vue-router';
import routes from '../routes';

const router = createRouter({
    history: createWebHistory(__BASE_PATH__),
    routes: [
        ...routes,
        {
            path: '/callback',
            component: () => import('../pages/Dashboard.vue'),
        },
    ],
});

export default router;
